import request from '../../utils/request'
import server from './config'
export default {
    /**
     * 服务包订单详情
     */
    servicePackOrderInfo:(data)=>{
        console.log('==',data)
        return request({
            url:`${server.MS_DOCTOR_CONSUMMER}/prescription/1/servicePackageInfo`,
            method: 'post',
            data
        })
    },

    /**
     * 服务包详情
     */
    getDetailById:(data)=>{
        console.log('==',data)
        return request({
            url:`${server.MS_DOCTOR_CONSUMMER}/service/agg/1/getDetailById`,
            method: 'post',
            data
        })
    },

    /**
     * 药品订单详情
     */
    drugOrderInfo (data) {
        return request({
            url: `${server.MS_DOCTOR_CONSUMMER}/prescription/1/drugOrderInfo`,
            method: 'post',
            data
        })
    },

    /**
     * 商品详情
     */
    drugInfo (data) {
        return request({
            url: `${server.MS_DOCTOR_CONSUMMER}/prescription/1/drugInfo`,
            method: 'post',
            data
        })
    },

     /**
     * 保单详情
     */
    insuranceEnterGroupInfoGetById (data) {
        return request({
            url: `${server.MS_DOCTOR_CONSUMMER}/insurance/1/insuranceEnterGroupInfoGetById`,
            method: 'post',
            data
        })
    },

    /**
     * 处方详情
     */
    prescriptionInfo: (data) => {
        return request({
            url: `${server.MS_DOCTOR_CONSUMMER}/prescription/1/prescriptionInfo`,
            method: 'post',
            data
        })
    },

    //获取提醒 表单详情
    getremindOrFormDetail:(data)=>{
        return request({
        url:`${server.MS_DOCTOR_CONSUMMER}/doctorPlanRecord/1/getNoticeOrFormDetailById`,
        method: 'post',
        data,
        })
    },
    /**
     * 获取文章详情
     */
    getArticleDetailById:(data)=>{
        return request({
            url:`${server.MS_DOCTOR_CONSUMMER}/doctorPlanRecord/1/getArticleDetailById`,
            method: 'post',
            data
        })
    },
     /**
     * 详情设置已读
     */
    setReaded:(data)=>{
        return request({
            url:`${server.MS_DOCTOR_CONSUMMER}/doctorPlanRecord/1/setReaded`,
            method: 'post',
            data
        })
    },
    /**
     * 根据恩必普、欧来宁数量查询关联的服务包服务内容
     */
    getManagerTemplateInfoList: (data) => {
        return request({
            url: `${server.MS_DOCTOR_CONSUMMER}/prescription/1/getManagerTemplateInfoList`,
            method: 'post',
            data
        })
    },
    /**
     * 推荐单详情
     */
    recommendDetail:(data)=>{
        return request({
        url:`${server.MS_DOCTOR_CONSUMMER}/prescription/1/getOtcInfoDetailById`,
        method: 'post',
        data
        })
    },

}



// WEBPACK FOOTER //
// ./src/api/modules/doctorApi.js